import React from "react";

 const Icon1 = ({ className }) => {
  return (
    <svg
      className={`icon-1 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" clipPath="url(#clip0_253_1104)">
        <path
          className="path"
          d="M5 12H19M12 5V19"
          stroke="#F5F5F5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>

      <defs className="defs">
        <clipPath className="clip-path" id="clip0_253_1104">
          <rect className="rect" fill="white" height="24" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Icon1;